import { logo } from "utils/assets_exports/images";

const FakeNav = () => {
    return (
        <div className="fake-nav pt-10">
            <a href="/" className="logo">
                <img src={logo} width="112" height="28" alt="" />
            </a>
        </div>
    );
};

export default FakeNav;
